import { useState } from 'react';
import type { Metadata } from '@/services/metadata';

export default () => {
  const [showForm, setShowForm] = useState(false);
  const [pickedData, setPickedData] = useState<Metadata | null>(null);
  const [loading, setLoading] = useState(false);

  const closeForm = () => {
    setShowForm(false);
    setPickedData(null);
  };

  const openCreateForm = () => {
    setPickedData(null);
    setShowForm(true);
  };

  const openEditForm = (data: Metadata) => {
    setPickedData(data);
    setShowForm(true);
  };

  return {
    // State
    showForm,
    pickedData,
    loading,
    // Actions
    setShowForm,
    setPickedData,
    setLoading,
    closeForm,
    openCreateForm,
    openEditForm,
  };
};
